<ul class="view-legend" aria-label="Legend">
    <li
        class="view-legend__item"
        *ngFor="let item of legend"
        tabindex="0">

        <div class="view-legend__color mh-2" [style.background-color]="getComputedColor(item.colors)">
        </div>

        <div class="view-legend__content text-14">
            <div>{{ item.label }}</div>
            <div *ngIf="item.description" class="mv-2">{{ item.description }}</div>
        </div>
        
    </li>
</ul>
